import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import Panel from './Panel';
import { IconForecast } from './icons';

const compact = (n) => new Intl.NumberFormat('fr-FR', { notation: 'compact', maximumFractionDigits: 1 }).format(n);

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="tooltip">
      <div className="tooltip__h">{label}</div>
      {payload.map((p) => (
        <div key={p.dataKey} style={{ color: p.color, fontWeight: 600, fontSize: 13 }}>
          {p.name} : {Number(p.value).toLocaleString('fr-FR')}
        </div>
      ))}
    </div>
  );
}

/** Prévision LSTM 24 h (appels + SMS) — sortie réelle du modèle (Dataset 1). */
export default function LstmForecastChart({ data, delay = 0 }) {
  const series = data?.series || [];
  const pic = data?.pic_appels;

  return (
    <Panel
      icon={IconForecast}
      title="Prévision réseau — modèle LSTM"
      sub={data?.modele || 'LSTM'}
      badge={pic ? `pic appels ${compact(pic.valeur)} à ${pic.heure}` : 'IA'}
      delay={delay}
    >
      <div className="chart-legend">
        <span><i style={{ background: '#0d9488' }} /> Appels prévus</span>
        <span><i style={{ background: '#f59e0b' }} /> SMS prévus</span>
      </div>
      <div className="chart-wrap">
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={series} margin={{ top: 8, right: 12, left: 4, bottom: 0 }}>
            <CartesianGrid stroke="#eef2f6" vertical={false} />
            <XAxis dataKey="heure" tickLine={false} axisLine={false} interval={3} tick={{ fontSize: 11 }} dy={6} />
            <YAxis tickLine={false} axisLine={false} width={48} tick={{ fontSize: 11 }} tickFormatter={compact} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ display: 'none' }} />
            <Line type="monotone" dataKey="appels" name="Appels" stroke="#0d9488" strokeWidth={2.6} dot={false} animationDuration={900} />
            <Line type="monotone" dataKey="sms" name="SMS" stroke="#f59e0b" strokeWidth={2.4} dot={false} strokeDasharray="5 4" animationDuration={900} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Panel>
  );
}
